/*=========================================================================================
  File Name: moduleStockGetters.js
  Description: Supplier Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
  GetAllSuppliers(state) {
    return state.suppliers.data;
  },
};
